module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"edit":"Edit link tree","delete":"Delete link tree"},"es":{"edit":"Editar arbol de links","delete":"Eliminar arbol de links"}}')
  delete Component.options._Ctor
}
